/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Container } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import ItemsListSpinner from '~/modules/ecommerceCoreUI/components/listViewLayout/ItemsListSpinner';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';
import SubDepartmentsInfo from './SubDepartmentsInfo';
import ShopDepartmentsTabs, { departmentIsFeatured } from './ShopDepartmentsTabs';
import ShopDepartmentsQuery from './ShopDepartmentsQuery';
import SubDepartmentMenu from './SubDepartmentMenu';

const CategoriesContainer = styled.div`
  position: relative;
`;

const SubdepartmentWrapper = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
`;

class ShopTracks extends Component {
  state = {
    showMenu: false,
    dropdownWidth: 0,
    taxonData: null,
  };

  componentDidUpdate = () => {
    if (!this.state.taxonData
      && this.props.queryResult?.taxons !== undefined
      && this.props.queryResult?.taxons.length > 0
      && !this.props.isLoading) {
      this.setState({
        activeDepartment: this.props.match.params.trackId
          ? this.props.match.params.trackId
          : this.props.queryResult?.taxons.length > 0 && this.props.queryResult?.taxons[0].ref_id,
        currentDepartmentId: this.props.match.params.subDepId || this.props.queryResult?.taxons[0]?.children[0].ref_id,
        taxonData: this.props.match.params.trackId
          ? this.props.queryResult?.taxons.length > 0
          && this.props.queryResult?.taxons.find(t => t.ref_id === this.props.match.params.trackId)
          : this.props.queryResult?.taxons.length > 0 && this.props.queryResult?.taxons[0],
      });
    }
  }

  showSubDepartments = (e, taxon) => {
    let leftPosition = 0;
    let dropdownWidth = 0;
    if (this.state.taxonData.ref_id !== taxon.ref_id || !this.state.showMenu) {
      const containerLeft = document.getElementById('shopDetailsContainer').getBoundingClientRect().left;
      if (e.target.parentNode.classList[0] === 'menu-item' || e.target.parentNode.classList[0] === 'item') {
        dropdownWidth = e.target.parentNode.getBoundingClientRect().width;
        leftPosition = e.target.parentNode.getBoundingClientRect().left - containerLeft;
      }
      this.setState({
        taxonData: taxon,
        leftPosition,
        dropdownWidth,
        showMenu: true,
      });
    } else {
      this.hideMenu();
    }
  };

  showProducts = (taxon, subDepartmentId) => {
    this.setState({
      currentDepartmentId: taxon.ref_id,
      showMenu: false,
      activeDepartment: subDepartmentId,
    });

    const { history } = this.props;
    const { vendorID, vendorName } = this.props.match.params;

    const department = this.props.queryResult.taxons.find(t => t.ref_id === subDepartmentId);
    history.push(urlFor('getProductTracksLink', [department, vendorID, vendorName, taxon.name, taxon.ref_id]));
  }

  handleDepartmentClick = (e, taxon) => {
    if (!departmentIsFeatured(taxon.caption)) {
      this.showSubDepartments(e, taxon);
      if (this.props.media.maxTablet) {
        this.showProducts(taxon.children[0], taxon.ref_id);
      }
    } else {
      this.showProducts(taxon.children[0], taxon.ref_id);
      this.setState({ taxonData: taxon });
    }
  }

  hideMenu = () => {
    this.setState({ showMenu: false });
  }

  render() {
    const {
      activeDepartment,
      currentDepartmentId,
      taxonData,
      leftPosition,
      showMenu,
      dropdownWidth,
    } = this.state;
    const {
      queryResult,
      media,
      isLoading,
    } = this.props;

    if (this.props.queryResult && this.props.queryResult.taxons === 0) {
      return false;
    }

    return (
      isLoading ? (
        <Container>
          <ItemsListSpinner isVertical oneRow itemsCount={7} />
        </Container>
      ) : (
        queryResult?.taxons.length > 0 && (
        <React.Fragment>
          <ShopDepartmentsTabs
            taxons={queryResult?.taxons}
            activeDepartment={activeDepartment}
            handleDepartmentClick={this.handleDepartmentClick}
            selectDepartment={this.selectDepartment}
            showMenu={showMenu}
          />
          {/* shopDetailsContainer is important. Don't change. */}
          <Container id="shopDetailsContainer">
            {(showMenu || media.maxTablet) && !departmentIsFeatured(taxonData?.caption) && (
            <React.Fragment>
              {media.minDesktop && <SubdepartmentWrapper onClick={() => this.hideMenu()} />}
              <CategoriesContainer>
                <SubDepartmentMenu
                  taxonData={taxonData}
                  leftPosition={leftPosition}
                  showProducts={this.showProducts}
                  dropdownWidth={dropdownWidth}
                />
              </CategoriesContainer>
            </React.Fragment>
            )}
            <Spacer sizedepartmentIsFeatured={1.5} />
            {currentDepartmentId && (
            <SubDepartmentsInfo
              currentDepartmentId={currentDepartmentId}
              vendorID={this.props.match.params.vendorID}
              vendorName={this.props.match.params.vendorName}
              featuredId={this.props.queryResult.taxons[0].ref_id}
            />
            )}
          </Container>
          <Separator customColorTone="#f9f9f9" separatorLength="full" separatorWeight={1.5} spacerSize={[1.5, 1.5, 2.5]} />
        </React.Fragment>
        )
      )
    );
  }
}

ShopTracks.defaultProps = {
  media: null,
  queryResult: null,
};

ShopTracks.propTypes = {
  history: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  queryResult: PropTypes.shape({
    taxons: PropTypes.arrayOf(PropTypes.shape({
      ref_id: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({})),
    })),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      vendorID: PropTypes.string,
      vendorName: PropTypes.string,
      trackId: PropTypes.string,
      subDepId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  media: PropTypes.shape({
    minDesktop: PropTypes.bool,
    maxTablet: PropTypes.bool,
  }),
};

export default withRouter(withMedia(withRootQuery(
  ShopTracks,
  ShopDepartmentsQuery,
  ShopTracks,
  props => ({
    vendorID: props.vendorID,
  }),
)));
